import { ColoredTextFindReplaceItem, ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { RowExtractorTransformRule } from 'src/app/domainObjects/rowExtractorTransform';
import { ExtractorStartRuleType, ExtractorEndRuleType } from 'src/app/messaging/engine';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';

export class RowExtractorRuleViewModel extends TransformRuleViewModel {
    sourceColumn: string;
    targetColumn: string;
    startRuleType: ExtractorStartRuleType;
    startPattern: string;
    startOffset: number;
    endRuleType: ExtractorEndRuleType;
    endPattern: string;
    endOffset: number;
    maxSearch: number;
    minLength: number;
    maxLength: number;
    findReplaceList?: ColoredTextFindReplaceItem[];
    matchAll: boolean;
    ignoreSpaces: boolean;
    matchCase: boolean;
    
    hits?: number;
    sampleHits?: number;
    groupHits?: number;
    sampleGroupHits?: number;
    
    tooltipMessage:string;
    tooltipType:string;
    
    constructor(rule: RowExtractorTransformRule) {
      super(rule.ruleId, rule.index, rule.run, rule.ruleName);
  
      this.sourceColumn = rule.sourceField;
      this.targetColumn = rule.targetField;
      this.startPattern = rule.startString;
      this.startOffset = rule.startChars;
      this.startRuleType = rule.startRule;
      this.endPattern = rule.endString;
      this.endOffset = rule.endCharsLen;
      this.endRuleType = rule.endRule;

      let colorIndex = 0;
      //this.findReplaceList = rule.findReplace.map(r => new ColoredTextFindReplaceItem(r.find,r.replace, NamedColorList[colorIndex++])) ?? []; 
      this.findReplaceList = rule.findReplace 
        ? Object.entries(rule.findReplace).map(([find, replace], index) => {
            // Reset or cycle through the NamedColorList array with colorIndex modulo NamedColorList length
            const color = NamedColorList[index % NamedColorList.length];
            return new ColoredTextFindReplaceItem(find, replace, color);
          })
        : [];
      //this.findString = rule.resultFind;
      //this.replaceWith = rule.resultReplace;
      this.maxSearch = rule.maxSearch;
      this.minLength = rule.minLength;
      this.maxLength = rule.maxLength;
      this.name = rule.name;
      this.ignoreSpaces = rule.ignoreSpaces;
      this.matchCase = rule.matchCase;
      this.matchAll = rule.matchAll;
      this.run = rule.run;
      
    }
  
    toRowExtractorRule(): RowExtractorTransformRule {
      const rule = new RowExtractorTransformRule();
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.sourceField = this.sourceColumn;
      rule.targetField = this.targetColumn;
      rule.startRule = this.startRuleType;
      rule.startString = this.startPattern;
      rule.startChars = this.startOffset;
      rule.endRule = this.endRuleType;
      rule.endString = this.endPattern;
      rule.endCharsLen = this.endOffset;
      rule.maxSearch = this.maxSearch;
      rule.minLength = this.minLength;
      rule.maxLength = this.maxLength;
      if(this.findReplaceList.length===0){
        rule.findReplace=undefined;
      }else{
        rule.findReplace={};
        this.findReplaceList.forEach(item => {
          rule.findReplace[item.find] = item.replace;
        });
      }
      rule.matchAll = this.matchAll;
      rule.ignoreSpaces = this.ignoreSpaces;
      rule.matchCase = this.matchCase;
      rule.run = this.run;

      return rule;
    }
  }
